import { buzdagi, cicekler, sonbahar, yesil, yol } from "./img";

export const photos = [
    {
        id:1,
        image:buzdagi
    },
    {
        id:2,
        image:cicekler
    },
    {
        id:3,
        image:sonbahar
    },
    {
        id:4,
        image:yesil
    },
    {
        id:5,
        image:yol
    },
]